import React from 'react';
import { Button, Card, Form, Input, DatePicker, Select, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import api from '../api/client';

const CompanyOrderNewPage: React.FC = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleSubmit = async (values: any) => {
    const payload = {
      ...values,
      date: values.date ? values.date.format('YYYY-MM-DD') : null,
    };
    try {
      const res = await api.post('/company-orders', payload);
      message.success('Приказ создан');
      navigate(`/company-orders/${res.data.id}`);
    } catch {
      message.error('Ошибка создания');
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/company-orders')}>
          Назад к списку
        </Button>
      </div>

      <Card title="Новый приказ">
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item name="number" label="Номер">
            <Input placeholder="Номер приказа" />
          </Form.Item>
          <Form.Item name="date" label="Дата">
            <DatePicker format="DD.MM.YYYY" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item name="title" label="Название" rules={[{ required: true, message: 'Введите название' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="content" label="Текст" rules={[{ required: true, message: 'Введите текст' }]}>
            <Input.TextArea rows={8} placeholder="Текст приказа..." />
          </Form.Item>
          <Form.Item name="status" label="Статус" initialValue="active" rules={[{ required: true }]}>
            <Select
              options={[
                { value: 'active', label: 'Действует' },
                { value: 'cancelled', label: 'Отменён' },
                { value: 'draft', label: 'Черновик' },
              ]}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Создать
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CompanyOrderNewPage;
